import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {DomSanitizer} from "@angular/platform-browser";


@Component({
    selector: 'privacy-form-dialog',
    templateUrl: './setting-form.component.html',
    styleUrls: ['./setting-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class PrivacyFormDialogComponent implements OnInit
{
  action: string;
  dialogTitle;
  public editorContent = ``;
  public editorConfig = {
    placeholder: "",
    modules: {
      toolbar: '#toolbar'
    }
  };
  title;
  active;
  html;
  constructor(
    public dialogRef: MatDialogRef<PrivacyFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any, private satinaizer: DomSanitizer
  )
  {
    this.editorContent = data.privacy;
  }

  ngOnInit()
  {

  }
}

